import firebase from '@/firebase.config'
import store from '@/store'

const initialiseUser = async (cred, authType, userType) => {
  // cred is the user's credentials from authenticating
  // authType is the authenticator e.g. Email, Google, Microsoft etc
  // userType is STUDENT or LECTURER

  // Create a user document in Firestore if one does not exist
  const userRef = firebase.firestore().collection('users').doc(cred.user.uid)
  let userData = null
  const doc = await userRef.get()
  if (!doc.exists){
    userData = {
      email: cred.user.email,
      displayName: cred.user.displayName,
      created: firebase.firestore.Timestamp.now(),
      userType: userType,
      authType: authType,
      showGoogleMeetGuide: true
    }
    await userRef.set(userData)

    if (userType === 'LECTURER') {
      await store.dispatch('addLecturer', {
        userId: cred.user.uid,
        lecturerData: { parentPath: 'root', completedSteps: [] }
      })
    }

    // Set Google analytics property for userType
    firebase.analytics().setUserProperties({
      userType: userType
    })
    // Report the signup to Google Analytics
    firebase.analytics().logEvent('sign_up', {
      method: authType
    })
  } 
  else {
    userData = doc.data()

    // Set Google analytics property for userType
    // Get this from the user doc, in case they have used the wrong sign in form
    // e.g. a lecturer has signed in with student form or vice versa
    firebase.analytics().setUserProperties({
      userType: doc.data().userType
    })

    // User document exists, so this is a login
    firebase.analytics().logEvent('login', {
      method: authType
    })
  }
  // Store auth data in Vuex
  await store.dispatch("storeAuthUser", { authUser: cred.user, userData: userData })
}

export { initialiseUser }